import Modal from './containers/ModalContainer';
import modalReducer, { openModal as modalOpen } from 'modal/modal';

export default Modal;
export const reducer = modalReducer;
export const openModal = modalOpen;
